module.exports = __webpack_public_path__ + "static/media/gapFillBlankFrames.cfd642fa.png";